import { render, staticRenderFns } from "./create.vue?vue&type=template&id=69c8aff5&"
import script from "./create.vue?vue&type=script&lang=js&"
export * from "./create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wwwroot\\dealer-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69c8aff5')) {
      api.createRecord('69c8aff5', component.options)
    } else {
      api.reload('69c8aff5', component.options)
    }
    module.hot.accept("./create.vue?vue&type=template&id=69c8aff5&", function () {
      api.rerender('69c8aff5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/center/create.vue"
export default component.exports